import { Component, Input } from '@angular/core';

@Component({
  selector: 'vnm-date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.scss']
})
export class DateComponent {
  @Input() date: string | Date;
  @Input() dateFormat = 'longDate';
  @Input() timeFormat = 'shortTime';
  @Input() showDate = true;
  @Input() showTime = true;
  @Input() separator = ', ';
  @Input() fallback = 'app.never';
  @Input() relative = false;
  @Input() timeZone: string | null = null; // dates will render as users local time, unless overridden

  get hasDateValues(): boolean {
    return this.date && this.includeDate && this.dateFormat && this.includeTime;
  }

  get includeDate(): boolean {
    return this.showDate && this.dateFormat !== null;
  }

  get includeTime(): boolean {
    return this.showTime && this.timeFormat !== null;
  }
}
